import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

const NON_STANDARD_GRAY = '#F2F2F2';

export const Wrapper = styled.div`
	display: flex;
	position: relative;
	min-height: 400px;
`;

export const FluidSection = styled.div`
	width: 100%;
	padding: 0 32px;
	position: relative;
	background: ${({ dark }) => (dark ? colors.grey1 : 'unset')};
`;

export const LoadingContainer = styled.div`
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	z-index: 10;
	background-color: rgba(255, 255, 255, 0.8);
`;

export const NoDataWrapper = styled.div`
	width: 100%;
	height: 620px;
	background-color: ${NON_STANDARD_GRAY};
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-around;
	position: relative;
	left: -32px;
	width: calc(100% + 64px);
`;
